import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Supervivencia } from 'src/app/modelos/supervivencia';
import { SupervivenciaService } from 'src/app/services/supervivencia.service';

@Component({
  selector: 'app-certificado-supervivencia-qr',
  templateUrl: './certificado-supervivencia-qr.component.html',
  styleUrls: ['./certificado-supervivencia-qr.component.css']
})
export class CertificadoSupervivenciaQrComponent implements OnInit {

    contratantes:any;
     domiciliario: Supervivencia = new Supervivencia();
   
     constructor(private rutaActiva: ActivatedRoute,private supervivenciaService:SupervivenciaService,
      private spinner: NgxSpinnerService) { }
   
     ngOnInit() {
   
       this.spinner.show();
       this.supervivenciaService.ObtenerPorCuid(this.rutaActiva.snapshot.params.id).subscribe(response => {
         this.spinner.hide();
         this.domiciliario = response.certificados[0];
   
         this.contratantes = response.participantes;
        
        
       });
   
   
     }
  
}
